var map = {
	"./bg/bg-dark.png": "954a",
	"./bg/bg-light.png": "cb38",
	"./chart@2x.png": "6fbe",
	"./coin/ada.png": "a26a",
	"./coin/avalanche.png": "b066",
	"./coin/bat.png": "0af0",
	"./coin/bnb.png": "b1c6",
	"./coin/btc.png": "1dfd",
	"./coin/dogecoin.png": "cae4",
	"./coin/eth.png": "0336",
	"./coin/link.png": "4436",
	"./coin/ltc.png": "8562",
	"./coin/mana.png": "c2f5",
	"./coin/solana.png": "06db",
	"./coin/sxp.png": "e16b",
	"./coin/usdc.png": "46cb",
	"./coin/usdt.png": "456f",
	"./coin/xvs.png": "1b5f",
	"./coin/zil.png": "13be",
	"./error.png": "fa93",
	"./home.png": "28ea",
	"./home/dash1-dark.png": "b679",
	"./home/dash1-light.png": "0f02",
	"./home/dash2-dark.png": "3d0f",
	"./home/dash2-light.png": "fc53",
	"./logo-dark.png": "59da",
	"./logo-light.png": "ea27",
	"./logo-mini-dark.png": "b588",
	"./logo-mini.png": "a2c8",
	"./logo.png": "9d64",
	"./logo2.png": "dd88",
	"./qrcode.png": "a76d",
	"./users/10.png": "bd80",
	"./users/12.png": "d968",
	"./users/14.png": "7366",
	"./users/2.png": "0485"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";